<div class="pageheader">
  <div class="page-title">
    <h1>Scheduler task log</h1>
    <div class="btn-group">
      <button type="button" class="btn btn-link" (click)="refresh()">
        Refresh <ep-svg-icon icon="repeat">
      </ep-svg-icon>
    </button>
  </div>
</div>
</div>

<dx-data-grid biz-grid [dataSource]='loggedSchedules' [showBorders]="true" [bizSetAllowColumnReordering]="false"
  [bizSetSearchPanel]="false" [bizHideSelectedRowsComponent]="true"
  [masterDetail]="{ enabled: true, template: 'detail' }">

  <dxi-column dataField="StartDate" caption="Started" dataType="date" [format]="dateFormat" width="16em"
    alignment="center" sortOrder="desc">
  </dxi-column>
  <dxi-column dataField="LogLevel" caption="Status" cellTemplate="status" width="8em" alignment="center">
  </dxi-column>
  <dxi-column dataField="EndDate" caption="Finished" dataType="date" [format]="dateFormat" width="16em"
    alignment="center" [visible]="false">
  </dxi-column>
  <dxi-column dataField="Duration" caption="Duration (sec.)" dataType="number" width="12em">
    <dxo-format type="fixedPoint" [precision]="3"></dxo-format>
  </dxi-column>
  <dxi-column dataField="LogId" caption="Id" dataType="string" width="20em" [visible]="false">
  </dxi-column>
  <dxi-column [allowReordering]="false" [allowGrouping]="false" [allowHiding]="false" [fixedPosition]="true">
  </dxi-column>

  <ng-container *dxTemplate="let row of 'status'">
    <div title="{{row.data.LogLevel}}">
      @if (row.data.LogLevel === 'Error') {
        <svg class="icon icon-times-circle-o error" viewBox="0 0 24 28">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#times-circle-o"></use>
        </svg>
      }
      @if (row.data.LogLevel === 'Warning') {
        <svg class="icon icon-dot-circle-o warning" viewBox="0 0 24 28">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#dot-circle-o"></use>
        </svg>
      }
      @if (row.data.LogLevel === 'Info') {
        <svg class="icon icon-check-circle-o info" viewBox="0 0 24 28">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#check-circle-o"></use>
        </svg>
      }
      @if (row.data.LogLevel === 'Debug') {
        <svg class="icon icon-check-circle-o debug" viewBox="0 0 24 28">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#check-circle-o"></use>
        </svg>
      }
    </div>
  </ng-container>

  <ng-container *dxTemplate="let row of 'detail'">
    <ep-scheduler-log-details [loggedScheduler]="row.data"></ep-scheduler-log-details>
  </ng-container>
</dx-data-grid>
